require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ./~/angular-aria/index.js
// module id = 86
// module chunks = 0